<template>
  <div :class="{inject:inject}">
    <div class="pa-2">
      <v-layout
        class="inputWrapTr ma-0"
        align-stretch
      >
        <div class="text-center">
          包裹體積
        </div>
        <v-layout
          align-center
          class="ma-0"
        >
          <input
            v-model="form.length"
            placeholder="長"
          >
          <input
            v-model="form.width"
            placeholder="寬"
          >
          <input
            v-model="form.height"
            placeholder="高"
          >
          <div class="caption">
            /CM
          </div>
        </v-layout>
      </v-layout>

      <v-layout
        class="inputWrapTr"
        align-stretch
      >
        <div class="text-center">
          包裹重量
        </div>
        <v-layout
          align-center
          class="ma-0"
        >
          <input
            v-model="form.weight"
            placeholder="重量"
          >
          <div class="caption">
            /KG
          </div>
        </v-layout>
      </v-layout>
    </div>

    <div class="btnWrap">
      <v-btn
        round
        block
        color="info"
        class="mt-3"
        @click="startCalc"
      >
        查詢
      </v-btn>
    </div>
    <template
      v-if="calcForm.weight > 0"
    >
      <div class="subTitle flex-grow-1 py-2 mt-6">
        運輸方式
      </div>
      <v-divider />

      <v-card
        flat
        class="ma-2 pa-2"
      >
        <v-card-text class="py-0">
          <div class="mb-2">
            <SrIcon
              transport="air"
              class="mr-1"
            />
            <span style="display: inline-block;width: 80px">空運</span>
            <span
              v-if="!weightLimitAir(limitCalcItem) && !volumeLimitAir(limitCalcItem)"
              class="green--text"
            >
              允許
              <i
                class="iconfont iconzhengque ml-1"
              />
            </span>
          </div>
          <div
            v-if="weightLimitAir(limitCalcItem)"
          >
            空運單件70KG以上包裹需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用(新台幣$4700起)，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
          </div>
          <div
            v-else-if="volumeLimitAir(limitCalcItem)"
          >
            物品單邊長度不可超過160cm，空運三邊若兩邊超過 70cm 和 85cm 需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用(新台幣$4700起)，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
          </div>
        </v-card-text>
      </v-card>

      <v-card
        flat
        class="ma-2 pa-2"
      >
        <v-card-text class="py-0">
          <div class="mb-2">
            <SrIcon
              transport="se"
              class="mr-1"
            />
            <span style="display: inline-block;width: 80px">海快</span>
            <span
              v-if="!volumeLimitSe(limitCalcItem) && !weightLimitSe(limitCalcItem)"
              class="green--text"
            >
              允許
              <i
                class="iconfont iconzhengque ml-1"
              />
            </span>
          </div>
          <div
            v-if="weightLimitSe(limitCalcItem)"
          >
            海快單件70KG以上包裹需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用，無法事先預估，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
          </div>
          <div
            v-else-if="volumeLimitSe(limitCalcItem)"
          >
            海快單件物品限制長寬高：180cm*180cm*長不限，重量超過70kg或是尺寸三邊有其中兩邊超過180cm無法通過海關x光機，需要轉一般倉正式報關，時效慢且會產生新台幣3-6千高額雜費，稅金另計，費用為實報實銷。
          </div>
          <div
            v-else-if="volumeLimitSeBy1210"
          >
            上海倉海快單件包裹尺寸 三邊其中兩邊超過110cm 需走一般倉正式報關，建議寄至其他海快倉。
          </div>
        </v-card-text>
      </v-card>

      <v-card
        v-if="suggestTips(limitCalcItem) === 'UnilateralLimit'"
        class="orange--text ma-2 pa-2"
        flat
      >
        提醒您，該包裹單邊長超過90cm，若合併打包在運輸途中極容易丟失或損壞，故需要單獨打包或與其他單邊長超過90cm的物品合包，巧巧郎關心您～
      </v-card>
      <v-card
        v-if="isLongAndThin(limitCalcItem)"
        class="orange--text ma-2 pa-2"
        flat
      >
        細長件與其他規格包裹合併下單極易折斷或丟失，因此只能與同為細長件的包裹合併打包或單獨打包。
      </v-card>
      <v-card
        v-if="limitHctLandAddr(limitCalcItem)"
        class="orange--text ma-2 pa-2"
        flat
      >
        以上適用本島寄送，外島需留意材積限制
        <Tooltips>
          寄台灣外島需注意⚠️<br>
          <br>
          尺寸限制：<br>
          貨件單邊&lt;150cm，單件&lt;25公斤，單件&lt;10才，才數計算為：長*寬*高/27000=才數，小數點無條件進位<br>
          <br>
          特殊商品才數認定：<br>
          扁型 才數=長*寬/900<br>
          長型 才數=長/30
        </Tooltips>
      </v-card>
    </template>
  </div>
</template>
<script>
import calc from 'calculatorjs'
import {
  volumeLimitAir,
  weightLimitAir,
  volumeLimitSe,
  weightLimitSe,
  singleMaxVolume,
  isLongAndThin,
  suggestTips,
  limitHctLandAddr,
} from '@g/utils/parcelUtils'
export default {
  props: {
    to: String,
    inject: Boolean,
  },
  data () {
    return {
      form: {
        weight: '',
        width: '',
        height: '',
        length: '',
      },
      calcForm: {},
      volumeLimitAir,
      weightLimitAir,
      volumeLimitSe,
      weightLimitSe,
      singleMaxVolume,
      isLongAndThin,
      suggestTips,
      limitHctLandAddr,
    }
  },
  computed: {
    limitCalcItem () {
      return {
        weight: this.calcForm.weight,
        width: Number(this.calcForm.width) * 10,
        height: Number(this.calcForm.height) * 10,
        length: Number(this.calcForm.length) * 10,
      }
    },
    volumeLimitSeBy1210 () {
      return volumeLimitSe({ ...this.limitCalcItem, jyAddrid: '1210' })
    },
  },
  mounted () {
    if (this.$route.query.startCalc) {
      Object.assign(this.form, this.$route.query)
      this.startCalc()
    }
  },
  methods: {
    async startCalc () {
      if (this.to) {
        this.$router.push({
          name: this.to,
          query: {
            ...this.form,
            startCalc: 1,
          }
        })
      } else {
        const f = {
          ...this.form,
          weight: calc(`${this.form.weight}*1000`),
          volWeight: 0,
          chgWeight: calc(`${this.form.weight}*1000`),
        }
        if (f.width > 0 && f.height > 0 && f.length > 0) {
          f.volWeight = calc(`${f.width}*${f.height}*${f.length}/6000*1000`)
          if (f.volWeight > f.weight * 3) {
            f.chgWeight = calc(`${f.volWeight}/2`)
          }
        }

        this.calcForm = f
      }
    },
  }
}
</script>
<style lang="postcss" scoped>
.inputWrapTr {
  > *:nth-child(1){
    width: 70px;
    padding: 10px 0;
  }
  > *:nth-child(2){
    padding: 10px 0;
    flex: 1;
    padding: 0 10px;
  }
  input {
    text-align: center;
    width: 50px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    margin-right: 5px;
    outline: none;
    background: #f9f9f9;
  }
}
.dark input {
  color: #fff;
}
.inject {
  border: 1px solid #eee;
  .btnWrap {
      padding: 0 30px 10px 30px;
  }
  .subTitle {
    margin-left: 10px;
  }
}
</style>
